<template>
    <section class="track-catalog" :class="{ 'track-catalog--full-width': isFullWidth }">
        <header class="track-catalog__header track-catalog__header--mobile" v-if="isMobile">
            <div class="track-catalog__tabs">
                <button
                    class="track-catalog__tab"
                    :class="{
                        'track-catalog__tab--active': activeTab === tab.id,
                    }"
                    v-for="tab in tabs"
                    :key="tab.id"
                    @click="setActiveTab(tab.id)"
                >
                    {{ tab.title }}
                </button>
            </div>
        </header>
        <header v-else class="track-catalog__header">
            <div class="track-catalog__tabs">
                <button
                    class="track-catalog__tab"
                    v-for="tab in tabs"
                    :key="tab.id"
                    :class="{
                        'track-catalog__tab--active': activeTab === tab.id,
                    }"
                    @click="setActiveTab(tab.id)"
                >
                    {{ tab.title }}
                </button>
            </div>
        </header>
        <main class="track-catalog__content">
            <component :is="tabs[activeTab].component" />
        </main>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';
import TabRecommendations from '@/views/track/components/tabs/TabRecommendations.vue';
import TabFavorites from '@/views/track/components/tabs/TabFavorites.vue';
import TabMyTrack from '@/views/track/components/tabs/TabMyTrack.vue';
import IconBurger from '@/views/track/icons/IconBurger.vue';
import IconClose from '@/views/track/icons/IconClose.vue';

export default {
    name: 'TrackCatalog',
    components: {
        TabRecommendations,
        TabFavorites,
        TabMyTrack,
        IconBurger,
        IconClose,
    },
    props: {
        isFullWidth: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isOpenToggleTab: false,
        };
    },
    computed: {
        ...mapGetters(['isMobile']),
        ...mapGetters('auth', ['isAuthorized']),
        ...mapGetters('track', ['activeTab']),

        tabs() {
            const baseTabs = {
                recommendations: {
                    id: 'recommendations',
                    title: 'Рекомендации',
                    component: TabRecommendations,
                },
            };

            if (this.isAuthorized) {
                baseTabs.favorites = {
                    id: 'favorites',
                    title: 'Избранное',
                    component: TabFavorites,
                };
            }

            if (this.isAuthorized) {
                baseTabs.myTrack = {
                    id: 'myTrack',
                    title: 'Мой трек',
                    component: TabMyTrack,
                };
            }

            return baseTabs;
        },
    },

    watch: {
        activeTab() {
            this.$emit('changeActiveTab', this.activeTab);
        },
    },
    methods: {
        setActiveTab(tabName) {
            this.$store.dispatch('track/setActiveTab', tabName);
        },
        onCloseToggleTab() {
            this.isOpenToggleTab = false;
        },
        onToggleTab(event) {
            event.stopPropagation();
            this.isOpenToggleTab = !this.isOpenToggleTab;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/variables';

.track-catalog {
    background-color: #fff;
    border-radius: urem(16);
    font-family: $font-montserrat;

    * {
        font-family: inherit;
    }

    @include on-desktop {
        width: urem(1136);
        box-shadow: 0 urem(2) urem(16) urem(0) rgba(70, 99, 171, 0.16);
    }

    &--full-width {
        @include on-desktop {
            width: 100%;
        }
    }

    &__header {
        background: rgba(217, 215, 231, 1);
        padding: urem(8) urem(20);
        position: relative;

        @include on-desktop {
            height: urem(80);
            padding: 0 urem(40);
            border-radius: urem(16);
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        }

        &--mobile {
            background: #fff;
            padding-bottom: 0;

            .track-catalog__tabs {
                display: flex;
                overflow-x: auto;
                gap: urem(8);
                padding-bottom: urem(10);
            }

            .track-catalog__tab {
                background-color: rgba(240, 239, 245, 1);
                color: rgba(105, 96, 159, 1);
                font-size: urem(16);
                font-weight: 500;
                line-height: urem(24);
                white-space: nowrap;
                height: urem(32);
                padding: 0 urem(10);
                min-width: auto;

                &--active {
                    background-color: rgba(105, 96, 159, 1);
                    color: #fff;
                }
            }
        }
    }

    &__tabs {
        display: flex;
        gap: urem(6);

        @include on-desktop {
            height: 100%;
            align-items: flex-end;
        }
    }

    &__tab {
        padding: urem(8) urem(16);
        border-radius: urem(100);
        background: none;
        border: none;
        color: rgba(152, 160, 169, 1);
        font-size: urem(16);
        font-weight: 600;
        min-width: urem(170);
        cursor: pointer;
        transition: all 0.3s ease;
        background-color: rgba(248, 248, 248, 1);

        &--active {
            color: rgba(105, 96, 159, 1);
            background-color: #fff;
        }

        @include on-desktop {
            padding: 0 urem(20);
            line-height: urem(40);
            border-radius: 0;
            border-top-left-radius: urem(16);
            border-top-right-radius: urem(16);
        }
    }

    &__content {
        border-radius: urem(16);
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    &__btn-toggle-tab {
        display: flex;
        align-items: center;
        gap: urem(8);
        color: rgba(105, 96, 159, 1);
        font-size: urem(16);
        font-weight: 600;
        line-height: urem(34);
        text-align: left;
        background: none;
        border: none;
        cursor: pointer;

        :deep(svg) {
            width: urem(24);
            height: urem(24);
        }
    }

    &__dropdown {
        position: absolute;
        top: urem(46);
        left: 50%;
        transform: translateX(-50%);
        width: 90%;
        background-color: #fff;
        border-radius: urem(16);
        padding: urem(5) urem(16);
        box-shadow: 0 urem(2) urem(16) 0 rgba(70, 99, 171, 0.1);
        display: flex;
        flex-direction: column;
        z-index: 101;
    }

    &__dropdown-tab {
        font-size: urem(16);
        font-weight: 400;
        line-height: urem(40);
        color: rgba(42, 38, 38, 1);
        text-align: left;
        background: none;
        border: none;
        cursor: pointer;

        &--active {
            color: rgba(105, 96, 159, 1);
            font-weight: 600;
        }
    }
}
</style>
